export const IS_NODE = typeof document === 'undefined';
